/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientOverviewDataModel } from '../../models/patient-overview-data-model';

export interface GetPatientOverviewData$Params {
  patientID?: number;
  startDate?: string;
  endDate?: string;
}

export function GetPatientOverviewData(http: HttpClient, rootUrl: string, params?: GetPatientOverviewData$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientOverviewDataModel>> {
  const rb = new RequestBuilder(rootUrl, GetPatientOverviewData.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientOverviewDataModel>;
    })
  );
}

GetPatientOverviewData.PATH = '/api/Supervisor/GetPatientOverviewData';
